import React, { useState } from "react";
import fetchData from "../../../api/fetchApi";
import { useParams, useNavigate } from "react-router-dom";
import PageHeader from "../../common/PageHeader";

export default function AddResellerUserPage() {
  const { id } = useParams();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" , username: ""});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      await fetchData(`finance/resellers/${id}/reseller-users`, "POST", form);
      setSuccess("تمت إضافة المستخدم بنجاح");
      setTimeout(() => navigate(`/finance/resellers/${id}/reseller-users`), 1200);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء الإضافة");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
      <PageHeader title="إضافة مستخدم موزع" total={0} stats={[]} />
      <form onSubmit={handleSubmit} className="max-w-lg mx-auto bg-gray-50 rounded-xl p-6 shadow mt-6 flex flex-col gap-4">
        <input name="name" value={form.name} onChange={handleChange} className="border rounded px-3 py-2" placeholder="اسم المستخدم" required />
        <input name="username" value={form.username} onChange={handleChange} className="border rounded px-3 py-2" placeholder="اسم المستخدم" required />
        <input name="email" value={form.email} onChange={handleChange} className="border rounded px-3 py-2" placeholder="البريد الإلكتروني" required type="email" />
        <input name="phone" value={form.phone} onChange={handleChange} className="border rounded px-3 py-2" placeholder="الهاتف" />
        <input name="password" value={form.password} onChange={handleChange} className="border rounded px-3 py-2" placeholder="كلمة المرور" required type="password" />
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {success && <div className="text-green-600 text-sm">{success}</div>}
        <div className="flex gap-2 justify-end">
          <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded" disabled={loading}>{loading ? "جاري الإضافة..." : "إضافة"}</button>
          <button type="button" className="bg-gray-200 px-4 py-2 rounded" onClick={() => navigate(-1)}>إلغاء</button>
        </div>
      </form>
    </div>
  );
}
